/** @deprecated since v5.0. Please use mat-table instead */
export enum TerraTextAlignEnum {
    LEFT = 'left',
    RIGHT = 'right',
    CENTER = 'center'
}
